export * from './useRootDocumentOrFail';
